const Make = require("../make/Make");
const Color = require("../utils/Color");
const {CAR_STATUS, ACQUISITION_TYPE} = require('./CarConstant');
const moment = require("moment");
const {fsMomentImport} = require("../utils/utils");

class Car {

    constructor({
                    id = '',
                    additionalID = {},
                    name = '',
                    highlightImage = '',
                    exteriorImage = [],
                    interiorImage = [],
                    file = [],

                    carModelID = '',
                    carModel = null,

                    vin = '',
                    plate = '',
                    color =  null,

                    receiptDate = null,
                    receiptDateConfirmed = false,
                    returnDate = null,
                    registrationDate = null,

                    netPrice = 0,
                    vat = 0.19,

                    acquisitionType = ACQUISITION_TYPE.RENT,
                    acquisitionCost = 0,
                    acquisitionMonthlyRent = 0,
                    deductibleCost = 0,

                    receiptMileage = 0,
                    maxMileageAdded = 0,
                    overdraftMileageCost = 0,

                    status = CAR_STATUS.INFLOW,

                    created = moment(),
                    createdBy = '',
                    updated = moment(),
                    updatedBy = '',

                } = {}) {

        this.id = id;
        this.additionalID = additionalID;
        this.name = name;
        this._highlightImage = highlightImage;
        this._exteriorImage = exteriorImage;
        this._interiorImage = interiorImage;
        this.file = Array.isArray(file) ? file : [];

        this.carModelID = carModelID;
        this.carModel = carModel;

        this.vin = vin;
        this.plate = plate;
        this.color = color ? new Color(color) : null;

        this.receiptDateConfirmed = receiptDateConfirmed;
        const dateField = ['receiptDate', 'returnDate', 'registrationDate' , 'created', 'updated'];
        [receiptDate, returnDate, registrationDate , created, updated].forEach((date, index) => {
            date = fsMomentImport(date)
            this[dateField[index]] = date && date.isValid() ? date : null
        })


        this.netPrice = netPrice;
        this.vat = vat;

        this.acquisitionType = ACQUISITION_TYPE[acquisitionType] ? acquisitionType : ACQUISITION_TYPE.RENT;
        this.acquisitionCost = acquisitionCost;
        this.acquisitionMonthlyRent = acquisitionMonthlyRent;
        this.deductibleCost = deductibleCost;

        this.receiptMileage = receiptMileage;
        this.maxMileageAdded = maxMileageAdded;
        this.overdraftMileageCost = overdraftMileageCost;

        this.status = CAR_STATUS[status] ? status : CAR_STATUS.INFLOW;

        this.createdBy = createdBy;
        this.updatedBy = updatedBy;

    }

    static get FS_COLLECTION_NAME() {
        return 'car'
    }

    static get STORAGE_DIR_NAME() {
        return 'car'
    }

    static get CAR_STATUS(){
        return CAR_STATUS
    }

    static get ACQUISITION_TYPE(){
        return ACQUISITION_TYPE
    }


    get highlightImage() {
        if(this._highlightImage){
            return this._highlightImage
        }
        else {
            return this.carModel && this.carModel.highlightImage ? this.carModel.highlightImage : ''
        }
    }

    set highlightImage(value) {
        this._highlightImage = value;
    }

    get exteriorImage() {
        if(this.carModel && Array.isArray(this.carModel.exteriorImage)){
            return [...this._exteriorImage, ...this.carModel.exteriorImage]
        }
        return this._exteriorImage;
    }

    set exteriorImage(value) {
        if(Array.isArray(value)){
            this._exteriorImage = value;
        }
    }

    get interiorImage() {
        if(this.carModel && Array.isArray(this.carModel.interiorImage)){
            return [...this._interiorImage, ...this.carModel.interiorImage]
        }
        return this._interiorImage;
    }

    set interiorImage(value) {
        if(Array.isArray(value)){
            this._interiorImage = value;
        }
    }

    validate(attribute) {

        if (attribute === undefined) {
            const attributes = Object.keys(this);
            try {
                attributes.map(attribute => {
                    if (!this._validate(attribute)) {
                        throw "validation error"
                    }
                });
            } catch (e) {
                return false
            }
            return true
        }

        return this._validate(attribute)
    }

    _validate(attribute) {

        try {
            switch (attribute) {
                case 'id':
                    return (typeof this[attribute] === 'string');
                default:
                    return false
            }
        } catch (e) {
            console.error('Validating CarModel with error:', e, attribute);
            return false
        }
    }

    toFirestore() {

        const file = {}
        try {
            this.file.forEach((f) => file[f.id] = f.toFirestore());
        } catch (e) {
            console.log('Could not convert files')
        }

        let data = {
            id: this.id,
            additionalID: this.additionalID,
            name: this.name,
            highlightImage: this._highlightImage,
            exteriorImage: this._exteriorImage,
            interiorImage: this._interiorImage,
            file,

            carModelID: this.carModelID,

            vin: this.vin,
            plate: this.plate,
            color: this.color ? this.color.toFirestore() : null,

            receiptDateConfirmed: this.receiptDateConfirmed,

            netPrice: this.netPrice,
            vat: this.vat,

            acquisitionType: this.acquisitionType,
            acquisitionCost: this.acquisitionCost,
            acquisitionMonthlyRent: this.acquisitionMonthlyRent,
            deductibleCost: this.deductibleCost,

            receiptMileage: this.receiptMileage,
            maxMileageAdded: this.maxMileageAdded,
            overdraftMileageCost: this.overdraftMileageCost,

            status: this.status,

            createdBy: this.createdBy,
            updatedBy: this.updatedBy,
        }

        // convert moment dates to js date
        const dateField = ['receiptDate', 'returnDate', 'registrationDate' , 'created', 'updated'];
        dateField.forEach((date) => data[date] = (this[date] && (typeof this[date].toDate === 'function'))?
            this[date].toDate() : null)


        return data
    }

    static parseFirestore(car, id = '',) {
        return new Car({
            ...car,
            id: id ? id : car.id || '',
        })
    }

    static fromFirestore(fsSnap, carModel = {}) {

        let data = {};
        if (fsSnap) {
            Object.keys(fsSnap).forEach((key) => {
                // the firestore object is not null
                if (fsSnap[key]) {
                    data[key] = Car.parseFirestore({
                        ...fsSnap[key],
                        carModel: carModel[fsSnap[key].carModelID] ? carModel[fsSnap[key].carModelID] : null,
                    }, key)
                }
            });
        }

        return data
    }

    isSame(object) {

        return Object.is(
            JSON.stringify(object),
            JSON.stringify(this))
    }
}

module.exports = Car;